import { applyDisplayProfile } from '../player/display-viewport.js';
import { programFingerprint } from './program-fingerprint.js';
import { normalizeProgram } from '../sync/program-version.js';
import { prefetchProgramMedia } from '../storage/prefetch-media.js';
import { shouldRotate } from './playback-status-store.js';

let currentProgram = null;
let currentSlotIdx = 0;
let lastFingerprint = '';
const subscribers = new Set();

export function setProgram(program) {
  program = normalizeProgram(program);
  if (!shouldRotate(program)) {
    currentProgram = null;
    lastFingerprint = program ? programFingerprint(program) : '';
    notify({ programChanged: true });
    return;
  }
  const fp = programFingerprint(program);
  const programChanged = fp !== lastFingerprint;
  lastFingerprint = fp;
  currentProgram = program;
  if (programChanged) {
    currentSlotIdx = 0;
  }
  if (program?.displayProfile) {
    applyDisplayProfile(program.displayProfile);
  }
  notify({ programChanged });
  if (program?.slots?.length) {
    void prefetchProgramMedia(program);
  }
}

export function getProgram() {
  return currentProgram;
}

/**
 * Apply display profile from latest poll without resetting playlist slot index.
 * @param {object | null | undefined} program
 */
export function syncDisplayProfileFromPoll(program) {
  if (!program?.displayProfile) return;
  if (currentProgram) {
    currentProgram = { ...currentProgram, displayProfile: program.displayProfile };
  }
  applyDisplayProfile(program.displayProfile);
}

export function getCurrentSlot() {
  if (!currentProgram?.slots?.length) return null;
  return currentProgram.slots[currentSlotIdx] ?? null;
}

export function advanceSlot() {
  if (!currentProgram?.slots?.length) return null;
  currentSlotIdx = (currentSlotIdx + 1) % currentProgram.slots.length;
  notify({ programChanged: false });
  return getCurrentSlot();
}

export function getCurrentSlotIdx() {
  return currentSlotIdx;
}

export function subscribeProgram(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

/**
 * @param {{ programChanged?: boolean }} meta
 */
function notify(meta = {}) {
  for (const fn of subscribers) {
    try {
      fn({
        program: currentProgram,
        idx: currentSlotIdx,
        programChanged: meta.programChanged ?? false,
      });
    } catch (e) {
      console.error('subscriber error', e);
    }
  }
}
